<template>
  <div :class="['hgl-list', { 'hgl-list--split': isDesktop }]">
    <!-- ═══════════════════════════════════════
         MAIN PANEL  (left column on desktop)
    ═══════════════════════════════════════ -->
    <div class="list__main">
      <!-- ─── TOP BAR ─── -->
      <div class="topbar">
        <div>
          <div class="brand">
            HGL - {{ siteName }}
          </div>
          <!-- <div class="station">HGL Ocean Mall · Operator</div> -->
        </div>
        <!-- <div class="op-badge">
          <span class="op-dot" />Bilal
        </div> -->
      </div>
      <!-- <v-btn @click="listChange">asdasd</v-btn> -->
      <!-- ─── TABS ─── -->
      <div class="tabs">
        <button
          v-for="(t, i) in tabOptions"
          :key="i"
          :class="['tab', 'tab--live', { active: activeTab === t.key }]"
          @click="activeTab = t.key"
        >
          <Icons
            v-if="t.myIcon"
            name="walk-in"
          />
          <v-icon
            v-else-if="t.icon"
            :class="t.key === 'live' && 'live-pulse'"
          >
            {{ t.icon }}
          </v-icon>
          {{ t.value }}
        </button>
      </div>
      <!--  -->
      <!-- ─── UPCOMING TAB ─── -->
      <div
        v-if="activeTab === 'upcoming'"
        class="tab-list"
      >
        <upcoming-tab
          ref="tab"
          :selected-booking="selectedBooking"
          @open-search="openSearch"
          @open-booking="openBooking"
        />
      </div>

      <!-- ─── LIVE SESSIONS TAB ─── -->
      <div
        v-if="activeTab === 'live'"
        class="tab-list"
      >
        <live-tab
          ref="tab"
          :selected-booking="selectedBooking"
          @open-live-detail="openLiveDetail"
        />
      </div>

      <!-- ─── HISTORY TAB ─── -->
      <div
        v-if="activeTab === 'history'"
        class="tab-list"
      >
        <history-tab
          ref="tab"
          :selected-booking="selectedBooking"
          @open-history="openHistory"
        />
      </div>

      <!-- ─── WALK IN SESSIONS TAB ─── -->
      <div
        v-if="activeTab === 'walk_in'"
        class="tab-list"
      >
        <walk-in-tab
          ref="tab"
          :selected-booking="selectedBooking"
          @open="openWalkInSession"
          @close="finishAndClose"
        />
      </div>
    </div>
    <!-- /list__main -->

    <!-- ═══════════════════════════════════════
         DETAIL PANEL
         Desktop  → sticky right column
         Mobile   → fixed overlay sheet
    ═══════════════════════════════════════ -->
    <transition name="fade-detail">
      <div
        v-if="showSheet || isDesktop"
        class="list__detail"
        @click.self="isDesktop ? null : closeSheet()"
      >
        <!-- ── FLOW CONTENT (booking selected) ── -->
        <detail-panel
          v-if="showSheet && selectedBooking"
          :selected-booking="selectedBooking"
          :view-mode="viewMode"
          :flow-step="flowStep"
          :flow-title="flowTitle"
          :flow-count="flowOptions?.length - 1"
          :checks="checks"
          :all-checked="allChecked"
          @close-sheet="closeSheet"
          @prev-step="prevStep"
          @go-step="flowStep = $event"
          @finish-and-close="finishAndClose"
          @onSearch="onSearch"
        />

        <!-- ── DESKTOP EMPTY STATE ── -->
        <div
          v-else-if="isDesktop"
          class="flow-panel flow-panel--empty"
        >
          <v-icon>mdi-calendar-blank-outline</v-icon>
          <h3>No booking selected</h3>
          <p>Tap a booking on the left to verify and start a session</p>
        </div>
      </div>
      <!-- /list__detail -->
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BookingOperator",
  components: {
    UpcomingTab: () => import("./tabs/Upcoming.vue"),
    LiveTab: () => import("./tabs/Live.vue"),
    HistoryTab: () => import("./tabs/History.vue"),
    WalkInTab: () => import("./tabs/WalkIn.vue"),
    //
    DetailPanel: () => import("./sections/DetailPanel.vue"),
    Icons: () => import("@/components/base/icons.vue"),
  },

  data() {
    return {
      activeTab: "upcoming",
      tabOptions: [
        {
          key: "upcoming",
          value: "Bookings",
          icon: "mdi-calendar-blank-outline",
        },
        {
          key: "walk_in",
          value: "Walk-In",
          myIcon: "walk-in",
        },
        { key: "live", value: "Live", icon: "mdi-lightning-bolt" },
        {
          key: "history",
          value: "History",
          icon: "mdi-clock-time-three-outline",
        },
      ],
      //
      showSheet: false,
      flowStep: 1,
      selectedBooking: null,
      checks: {
        booking_id_verified: false,
        cable_connected: false,
        connector_verified: false,
      },
      countdownSec: 0,
      countdownTimer: null,
      viewMode: "flow",
    };
  },

  computed: {
    ...mapGetters({
      authUser: "getUser",
      upcomingList: "bookingOperator/getUpcoming",
      liveSessionList: "bookingOperator/getLiveSession",
    }),
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    siteName() {
      if (this.authUser.isAdmin) {
        return this.authUser.name;
      }
      return this.authUser?.site_name?.join(", ") || "--";
    },
    //
    allChecked() {
      return (
        this.checks.booking_id_verified &&
        this.checks.cable_connected &&
        this.checks.connector_verified
      );
    },

    flowOptions() {
      const liveStep = ["", "Charging Started", "Take Payment", "Complete"];
      const step = [
        "",
        "Find Booking",
        "Verify Customer",
        "Safety Check",
        "Charging Started",
        // "Take Payment",
        // "Complete",
      ];
      return this.activeTab == "live" ? liveStep : step;
    },

    flowTitle() {
      if (this.viewMode === "summary") return "Session Receipt";
      else if (this.viewMode === "live-detail") return "Live Session";
      else if (this.viewMode === "walk-in-customer") return "Walk In Cutomer";
      // else if (this.viewMode === "live-detail") return "Session Receipt";
      return this.flowOptions[this.flowStep] || "";
    },
  },

  watch: {
    showSheet(val) {
      if (!this.isDesktop) {
        document.body.style.overflow = val ? "hidden" : "";
      }
    },
    isDesktop(val) {
      if (val) document.body.style.overflow = "";
    },
    activeTab() {
      this.closeSheet();
    },
    flowStep(val) {
      if (val == 3) {
        // this.$store.dispatch("bookingOperator/details", this.selectedBooking);
      } else if (val === 5) {
        // this.$store.dispatch(
        //   "bookingOperator/getPriceSummary",
        //   this.selectedBooking
        // );
      }
    },
  },

  beforeDestroy() {
    document.body.style.overflow = "";
    this.stopCountdown();
  },

  mounted() {},

  methods: {
    // listChange() {
    //   log("list change", this.$refs.tab);
    // },
    openSearch() {
      this.selectedBooking = {};
      this.flowStep = 1;
      this.checks = {
        booking_id_verified: false,
        cable_connected: false,
        connector_verified: false,
      };
      this.showSheet = true;
    },
    onSearch({ id, reg }) {
      if (!id && !reg) return;
      const booking = this.upcomingList.find((item) => {
        if (id) {
          return item.booking_id == id; // use === if types are same
        }
        return item.vehicle_reg_no?.toLowerCase() === reg?.toLowerCase();
      });
      if (!booking) {
        return this.$store.dispatch("alerts/error", "No Booking Record");
      }
      this.openBooking(booking);
    },

    //
    openBooking(bk) {
      this.selectedBooking = bk;

      this.checks = {
        booking_id_verified: bk.booking_id_verified,
        cable_connected: bk.cable_connected,
        connector_verified: bk.connector_verified,
      };

      if (
        bk.booking_id_verified &&
        bk.cable_connected &&
        bk.connector_verified
      ) {
        this.flowStep = 4;
        this.showSheet = true;
        return 0;
      }
      this.flowStep = 2;
      this.showSheet = true;
    },

    openLiveDetail(bk) {
      this.selectedBooking = bk;
      this.viewMode = "live-detail";
      // this.viewMode = "flow";
      this.showSheet = true;
    },
    openWalkInSession(bk) {
      this.selectedBooking = bk;
      this.viewMode = "walk-in-customer";
      // this.viewMode = "flow";
      this.showSheet = true;
    },
    openHistory(bk) {
      this.selectedBooking = bk;
      this.viewMode = "summary";
      this.showSheet = true;
    },
    //
    closeSheet() {
      this.showSheet = false;
      this.viewMode = "flow";
      if (this.isDesktop) this.selectedBooking = null;
    },
    prevStep() {
      if (this.flowStep > 1) this.flowStep--;
    },
    finishAndClose() {
      this.showSheet = false;
      this.selectedBooking = null;
      this.$refs.tab.fetchData();
    },
  },
};
</script>

<style>
/* ── TOKENS ── */
.hgl-list {
  /*  */
  --color2: #8fcf4d;
  --color3: #4ade80;
  --color4: #58d68d;
  --color5: #699836;
  /*  */
  --darkGreen: #1c5528;
  --lightGreen: #329748;
  --lighterGreen: #cdeed4;
  --gray: #e8e6dc;
  --red: red;
  /* --lighterGreen: #e7f6ed;
  --gradient: linear-gradient(var(--lightGreen), var(--darkGreen));
  */
  --gradient: linear-gradient(
    to bottom,
    var(--lightGreen) 0%,
    var(--darkGreen) 60%
  );
  --shadow: 0 4px 18px rgba(12, 57, 50, 0.08);
  /*  */
  --line: #e3ecea;
  --muted: #6a807b;
  --card: #ffffff;
  /*  */
  --bg: #f4f7f6;
  --amber: #e6a817;
  --amber-bg: #fff6e2;

  font-family: "Segoe UI", system-ui, -apple-system, sans-serif;
  background: var(--bg);
  color: var(--darkgreen);
  line-height: 1.45;
  min-height: 90vh;
}
.hgl-list * {
  box-sizing: border-box;
}

.text--red {
  color: red !important;
}
/* ══════════════════════════════════════
   MOBILE — single column, full width
══════════════════════════════════════ */
.hgl-list .list__main {
  background: var(--card);
  border-radius: 16px;
  height: calc(90vh);
  overflow: hidden;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  flex-direction: column;
}
/* Mobile: detail panel acts as overlay backdrop */
.hgl-list .list__detail {
  position: fixed;
  inset: 0;
  background: rgba(12, 57, 50, 0.55);
  z-index: 50;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
/* Mobile: flow panel slides up from bottom */
.hgl-list .flow-panel {
  background: var(--bg);
  width: 100%;
  max-width: 480px;
  border-radius: 24px 24px 0 0;
  max-height: 94vh;
  /* overflow-y: auto; */
  display: flex;
  flex-direction: column;
}
/* ══════════════════════════════════════
   DESKTOP — two-column split
══════════════════════════════════════ */
.hgl-list--split {
  display: grid;
  grid-template-columns: 400px 1fr;
  gap: 1.5rem;
  padding: 1.5rem;
  max-width: 1280px;
  margin: 0 auto;
  align-items: start;
}
/* Left column: scrollable card */
.hgl-list--split .list__main {
  border-radius: 16px;
  /* overflow: hidden;
  box-shadow: var(--shadow);
  position: sticky;
  top: 1.5rem;
  height: calc(90vh - 3rem);
  overflow-y: auto; */

  /*  */
  border-radius: 16px;
  height: calc(90vh - 3rem);
  overflow: hidden;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  flex-direction: column;
}
/* Right column: reset overlay styles, become a normal column */
.hgl-list--split .list__detail {
  position: sticky;
  top: 1.5rem;
  height: calc(90vh - 3rem);
  background: transparent;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  z-index: 1;
}

.hgl-list .tab-list {
  overflow-y: auto;
}
/* Desktop flow panel fills column */
.hgl-list--split .flow-panel {
  flex: 1;
  border-radius: 16px;
  max-height: 100%;
  max-width: none;
  width: 100%;
  box-shadow: var(--shadow);
  border: 1px solid var(--line);
  background: var(--card);
}
/* Desktop: body is the scrollable area; head+foot are flex-anchored */
.hgl-list--split .flow-body {
  flex: 1;
  overflow-y: auto;
}
/* Desktop: disable sticky inside panel (flexbox handles it) */
.hgl-list--split .flow-head {
  position: static;
  border-radius: 16px 16px 0 0;
}
.hgl-list--split .sheet-foot {
  position: static;
}
/* Desktop: topbar/tabs not sticky (already inside a sticky container) */
.hgl-list--split .topbar,
.hgl-list--split .tabs {
  position: static;
}
/* Empty state panel */
.hgl-list .flow-panel--empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: var(--muted);
  border: 1.5px dashed var(--line);
  padding: 2rem;
  background: var(--card);
}
.hgl-list .flow-panel--empty i {
  opacity: 0.25;
  margin-bottom: 16px;
  font-size: 5rem;
}
.hgl-list .flow-panel--empty h3 {
  font-size: 17px;
  color: var(--darkgreen);
  margin-bottom: 6px;
}
.hgl-list .flow-panel--empty p {
  font-size: 14px;
  max-width: 230px;
}
/* ── TOPBAR ── */
.hgl-list .topbar {
  background: var(--gradient);
  color: #fff;
  padding: 16px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: -0.5rem;
  z-index: 6;
}
.hgl-list .brand {
  font-weight: 700;
  font-size: 19px;
  letter-spacing: 0.3px;
}
.hgl-list .station {
  font-size: 12.5px;
  color: #a8d5d1;
  margin-top: 2px;
}

/* ── TABS ── */
.hgl-list .tabs {
  display: flex;
  background: var(--card);
  padding: 8px;
  gap: 8px;
  border-bottom: 1px solid var(--line);
  position: sticky;
  top: 5rem;
  z-index: 6;
}
.hgl-list .tab {
  flex: 1;
  padding: 13px 8px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  color: var(--muted);
  cursor: pointer;
  transition: 0.15s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  border: none;
  background: none;
  font-family: inherit;
}
.hgl-list .tab i,
.hgl-list .tab svg {
  width: 22px !important;
  height: 22px !important;
}
.hgl-list .tab svg g {
  fill: var(--muted);
}
.hgl-list .tab.active {
  background: var(--gradient);
  color: #fff;
}
.hgl-list .tab.active i,
.hgl-list .tab.active svg g {
  color: #fff;
  fill: #fff;
}
.hgl-list .tab.active:hover,
.hgl-list .tab.active:hover i {
  color: #fff;
}
.hgl-list .tab:hover,
.hgl-list .tab:hover i {
  color: var(--lightGreen);
}

/* ── ARRIVE CARD ── */
.hgl-list .arrive-card {
  margin: 14px 16px;
  background: var(--gradient);
  border-radius: 18px;
  padding: 20px;
  color: #fff;
  box-shadow: var(--shadow);
}
.hgl-list .arrive-card h2 {
  font-size: 18px;
  margin-bottom: 4px;
}
.hgl-list .arrive-card p {
  font-size: 13.5px;
  opacity: 0.9;
  margin-bottom: 16px;
}
/* ── LIVE PULSE ── */
.hgl-list .live-pulse {
  color: var(--lightGreen);
  animation: pulse-ring 1.2s ease-in-out infinite;
  filter: drop-shadow(0 0 6px var(--lightGreen));
}

@keyframes pulse-ring {
  0% {
    transform: scale(1);
    filter: drop-shadow(0 0 4px rgba(121, 227, 120, 0.6))
      drop-shadow(0 0 8px rgba(145, 240, 145, 0.4));
  }

  50% {
    transform: scale(1.2);
    filter: drop-shadow(0 0 8px rgb(143, 237, 168))
      drop-shadow(0 0 16px rgba(131, 188, 95, 0.9))
      drop-shadow(0 0 28px rgba(113, 216, 118, 0.7));
  }

  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 4px rgba(113, 184, 118, 0.6))
      drop-shadow(0 0 8px rgba(60, 198, 127, 0.4));
  }
}
.hgl-list .live-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.8px;
  color: var(--lightGreen);
  background: var(--lighterGreen);
  padding: 2px 8px;
  border-radius: 6px;
  margin-left: auto;
}
.hgl-list .live-tag--lg {
  font-size: 13px;
  padding: 5px 14px;
  border-radius: 20px;
  margin-left: 0;
}

.hgl-list .bk-id-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
/* ── LIVE STATS ── */
.hgl-list .live-stats {
  display: flex;
  align-items: center;
  background: var(--gradient);
  border-radius: 12px;
  padding: 12px 0;
  margin: 12px 0 8px;
}
.hgl-list .live-stat {
  flex: 1;
  text-align: center;
}
.hgl-list .live-stat__val {
  font-size: 1rem;
  font-weight: 800;
  color: #fff;
  line-height: 1.1;
}
.hgl-list .live-stat__unit {
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
}
.hgl-list .live-stat__lbl {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.55);
  margin-top: 3px;
  font-weight: 500;
}
.hgl-list .live-stat-div {
  width: 1px;
  height: 32px;
  background: rgba(255, 255, 255, 0.15);
}
/* ── EMPTY LIVE ── */
.hgl-list .empty-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 60px 24px;
  color: var(--muted);
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}
.hgl-list .empty-list i {
  opacity: 0.3;
}
/* ── LABELS ── */
.hgl-list .sec-label {
  padding: 18px 18px 8px;
  font-size: 13px;
  font-weight: 700;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

/* ── BUTTONS ── */
.hgl-list .big-btn {
  width: 100%;
  padding: 18px;
  border: none;
  border-radius: 14px;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: 0.15s;
  font-family: inherit;
}
.hgl-list .big-btn svg,
.hgl-list .big-btn i {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
.hgl-list .big-btn:active:not(:disabled) {
  transform: scale(0.98);
}
.hgl-list .btn-white {
  background: #fff;
  color: var(--darkGreen);
}
.hgl-list .btn-primary {
  background: var(--gradient);
  color: #fff;
}
.hgl-list .btn-primary:disabled {
  background: #c5d6d3;
  cursor: not-allowed;
}
.hgl-list .btn-primary:active:not(:disabled) {
  background: var(--lightGreen);
}
/* ── BOOKING CARDS ── */
.hgl-list .list {
  padding: 6px 16px 20px;
}
.hgl-list .bk-card {
  background: var(--card);
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: var(--shadow);
  border: 1px solid var(--line);
  cursor: pointer;
  transition: 0.15s;
  position: relative;
  overflow: hidden;
}
.hgl-list .bk-card:active {
  transform: scale(0.99);
}
.hgl-list .bk-card--sel {
  border-color: var(--lightGreen);
  box-shadow: 0 0 0 2px var(--lightGreen);
}
.hgl-list .stripe {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 6px;
}
.hgl-list .bk-card--due .stripe {
  background: var(--amber);
}
.hgl-list .bk-card--active .stripe {
  background: var(--lightGreen);
}
.hgl-list .bk-card--upcoming .stripe {
  background: var(--lightGreen);
}
.hgl-list .bk-id-badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.6px;
  color: var(--darkGreen);
  background: #e3ecea;
  padding: 3px 10px;
  border-radius: 6px;
  font-family: "Courier New", monospace;
}
.hgl-list .bk-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}
.hgl-list .bk-time {
  font-size: 22px;
  font-weight: 800;
  color: var(--darkGreen);
  letter-spacing: -0.5px;
}
.hgl-list .ampm {
  font-size: 14px;
  font-weight: 600;
  color: var(--muted);
}
.hgl-list .bk-sub {
  font-size: 12.5px;
  color: var(--muted);
  margin-top: 1px;
}
.hgl-list .bk-duration {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: var(--muted);
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid var(--line);
}
.hgl-list .bk-body {
  display: flex;
  align-items: center;
  gap: 12px;
}
.hgl-list .avatar {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: #e3ecea;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: var(--lightGreen);
  font-size: 18px;
  flex-shrink: 0;
}
.hgl-list .bk-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}
.hgl-list .bk-name {
  font-size: 16px;
  font-weight: 700;
}
.hgl-list .bk-veh {
  font-size: 13px;
  color: var(--muted);
  /* display: flex; */
  /* flex-direction: column; */
  /* align-items: center; */
  /* margin-top: 2px; */
  /* gap: 6px; */
  /* flex-wrap: wrap; */
}
.hgl-list .reg-tag {
  background: var(--darkGreen);
  color: #fff;
  font-size: 11.5px;
  font-weight: 700;
  padding: 4px 5px;
  border-radius: 6px;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.hgl-list .bk-port {
  text-align: right;
  flex-shrink: 0;
}
.hgl-list .port-num {
  font-size: 13px;
  font-weight: 800;
  color: var(--darkGreen);
}
.hgl-list .port-type {
  font-size: 11px;
  color: var(--muted);
}
.hgl-list .chev {
  color: var(--lightGreen);
  flex-shrink: 0;
}
/* ── STATUS PILLS ── */
.hgl-list .pill {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}
.hgl-list .pill .dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}
.hgl-list .pill-due {
  background: var(--amber-bg);
  color: #9a6e00;
}
.hgl-list .pill-due .dot {
  background: var(--amber);
}
.hgl-list .pill-up {
  background: #e9f4f2;
  color: var(--lightGreen);
}
.hgl-list .pill-up .dot {
  background: var(--lightGreen);
}
.hgl-list .pill-red {
  background: #ffe2e2;
  color: #ea5858;
}
.hgl-list .pill-red .dot {
  background: #ea5858;
}
.hgl-list .pill-active {
  background: var(--lighterGreen);
  color: var(--lightGreen);
}
.hgl-list .pill-active .dot {
  background: var(--lightGreen);
  animation: pulse 1.4s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}
/* ── FLOW HEAD ── */
.hgl-list .flow-head {
  background: var(--gradient);
  color: #fff;
  padding: 18px;
  border-radius: 15px 15px 0 0;
  position: sticky;
  top: 0;
  z-index: 5;
  flex-shrink: 0;
}
.hgl-list .sh-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.hgl-list .head-back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: var(--line);
  color: var(--darkgreen);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.hgl-list .head-back-btn:hover {
  background: #d0dedd;
}
.hgl-list .sh-row h2 {
  flex: 1;
}
.hgl-list .flow-head h2 {
  font-size: 18px;
  font-weight: 700;
}
.hgl-list .close-x {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
  line-height: 1;
}
.hgl-list .step-track {
  display: flex;
  gap: 6px;
  margin-top: 14px;
}
.hgl-list .step-dot {
  flex: 1;
  height: 5px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.25);
}
.hgl-list .step-dot.done {
  background: var(--lightGreen);
}
.hgl-list .step-dot.current {
  background: #fff;
}
/* ── FLOW BODY ── */
.hgl-list .flow-body {
  flex: 1;
}
.hgl-list .sheet-body {
  padding: 18px;
  overflow: auto;
}
.hgl-list .step-title {
  font-size: 13px;
  font-weight: 700;
  color: var(--lightGreen);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 4px;
}
.hgl-list .step-h {
  font-size: 21px;
  font-weight: 800;
  color: var(--darkGreen);
  margin-bottom: 16px;
}
/* Search */
.hgl-list .search-field {
  margin-bottom: 14px;
}
.hgl-list .search-field label {
  font-size: 13px;
  font-weight: 600;
  color: var(--muted);
  display: block;
  margin-bottom: 7px;
}
.hgl-list .search-field label .required {
  font-size: 13px;
  font-weight: 600;
  color: red;
}
.hgl-list .search-field input {
  width: 100%;
  padding: 16px;
  font-size: 18px;
  border: 2px solid var(--line);
  border-radius: 13px;
  outline: none;
  transition: 0.15s;
  background: #fff;
  letter-spacing: 1px;
  font-family: inherit;
}
.hgl-list .search-error input {
  border: 2px solid var(--red);
}
.hgl-list .search-field input:focus {
  border-color: var(--lightGreen);
}
.hgl-list .or-divider {
  text-align: center;
  color: var(--muted);
  font-size: 13px;
  font-weight: 600;
  margin: 10px 0;
  position: relative;
}
.hgl-list .or-divider::before,
.hgl-list .or-divider::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 38%;
  height: 1px;
  background: var(--line);
}
.hgl-list .or-divider::before {
  left: 0;
}
.hgl-list .or-divider::after {
  right: 0;
}
/* Verify */
.hgl-list .verify-card {
  background: #fff;
  border-radius: 16px;
  padding: 18px;
  box-shadow: var(--shadow);
  margin-bottom: 16px;
  border: 1px solid var(--line);
}
.hgl-list .vc-head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--line);
  margin-bottom: 16px;
}
.hgl-list .vc-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--lighterGreen);
  color: var(--lightGreen);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 22px;
  flex-shrink: 0;
}
.hgl-list .vc-name {
  font-size: 19px;
  font-weight: 800;
}
.hgl-list .vc-id {
  font-size: 13px;
  color: var(--muted);
  margin-top: 2px;
}
.hgl-list .vc-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
.hgl-list .vc-item .k {
  font-size: 12px;
  color: var(--muted);
  font-weight: 600;
  margin-bottom: 3px;
}
.hgl-list .vc-item .v {
  font-size: 15.5px;
  font-weight: 700;
}
.hgl-list .vc-item.full {
  grid-column: 1 / -1;
}
.hgl-list .big-reg {
  font-size: 20px;
  letter-spacing: 1.5px;
  background: var(--darkGreen);
  color: #fff;
  display: inline-block;
  padding: 6px 14px;
  border-radius: 8px;
}
.hgl-list .match-q {
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  color: var(--darkgreen);
  margin: 6px 0 14px;
}
/* Checklist */
.hgl-list .check-item {
  background: #fff;
  border: 2px solid var(--line);
  border-radius: 15px;
  padding: 18px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
  transition: 0.15s;
  width: 100%;
  text-align: left;
  font-family: inherit;
}
.hgl-list .check-item:active {
  transform: scale(0.99);
}
.hgl-list .check-item.checked {
  border-color: var(--lightGreen);
  background: var(--lighterGreen);
}
.hgl-list .check-box {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2.5px solid var(--line);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.15s;
  background: #fff;
}
.hgl-list .check-item.checked .check-box {
  background: var(--lightGreen);
  border-color: var(--lightGreen);
}
.hgl-list .check-box i {
  width: 20px;
  height: 20px;
  color: #fff;
  opacity: 0;
  transition: 0.15s;
}
.hgl-list .check-item.checked .check-box i {
  opacity: 1;
}
.hgl-list .check-text {
  font-size: 16px;
  font-weight: 700;
  flex: 1;
}
.hgl-list .check-text .sub {
  font-size: 12.5px;
  color: var(--muted);
  font-weight: 500;
  margin-top: 2px;
  display: block;
}
.hgl-list .check-item.checked .check-text .sub {
  color: var(--lightGreen);
}
/* Success / Step 4 */
.hgl-list .success-wrap {
  text-align: center;
  padding: 20px 0;
}
.hgl-list .success-ring {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: #e9f4f2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 18px;
  color: var(--lightGreen);
}
.hgl-list .success-ring--green {
  background: var(--lighterGreen);
  color: var(--lightGreen);
}
.hgl-list .success-ring--green i {
  background: var(--lighterGreen);
  font-size: 4rem;
  color: #20a390;
}
.hgl-list .success-wrap h2 {
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 6px;
}
.hgl-list .success-wrap .msg {
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 6px;
}
.hgl-list .success-wrap p {
  font-size: 15px;
  color: var(--muted);
  margin-bottom: 22px;
}
.hgl-list .warn-banner {
  background: var(--amber-bg);
  border: 1.5px solid var(--amber);
  border-radius: 13px;
  padding: 14px;
  display: flex;
  gap: 11px;
  align-items: flex-start;
  margin-bottom: 16px;
  text-align: left;
}
.hgl-list .warn-banner svg {
  color: var(--amber);
  flex-shrink: 0;
  margin-top: 1px;
}
.hgl-list .warn-banner .t {
  font-size: 14px;
  font-weight: 700;
  color: #9a6e00;
}
.hgl-list .warn-banner .d {
  font-size: 13px;
  color: #7a5800;
  margin-top: 2px;
}
.hgl-list .slot-timer {
  background: var(--darkGreen);
  border-radius: 16px;
  padding: 20px 16px 16px;
  text-align: center;
  margin: 16px 0;
  width: 100%;
}
.hgl-list .slot-timer__label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
  margin-bottom: 6px;
}
.hgl-list .slot-timer__clock {
  font-size: 52px;
  font-weight: 800;
  color: #fff;
  letter-spacing: 2px;
  font-variant-numeric: tabular-nums;
  line-height: 1;
  font-family: "Courier New", monospace;
}
.hgl-list .slot-timer__until {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 8px;
}
.hgl-list .success-detail {
  background: #fff;
  border-radius: 14px;
  padding: 16px;
  text-align: left;
  box-shadow: var(--shadow);
  margin-bottom: 8px;
}
.hgl-list .sd-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14.5px;
  border-bottom: 1px solid var(--line);
}
.hgl-list .sd-row:last-child {
  border-bottom: none;
}
.hgl-list .sd-row .k {
  color: var(--muted);
}
.hgl-list .sd-row .v {
  font-weight: 700;
}
.hgl-list .receipt-sent {
  color: var(--lightGreen) !important;
}

/* Payment */
.hgl-list .pay-summary {
  background: var(--gradient);
  color: #fff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 18px;
  text-align: center;
}
.hgl-list .pay-summary .lbl {
  font-size: 13px;
  opacity: 0.8;
  margin-bottom: 4px;
}
.hgl-list .pay-summary .amt {
  font-size: 38px;
  font-weight: 800;
  letter-spacing: -1px;
}
.hgl-list .pay-summary .kwh {
  font-size: 13.5px;
  opacity: 0.85;
  margin-top: 4px;
}
.hgl-list .pay-methods {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 18px;
  overflow: hidden;
}
.hgl-list .pay-opt {
  background: #fff;
  border: 2px solid var(--line);
  border-radius: 15px;
  padding: 18px 12px;
  text-align: center;
  cursor: pointer;
  transition: 0.15s;
  font-family: inherit;
}
.hgl-list .pay-opt:active {
  transform: scale(0.98);
}
.hgl-list .pay-opt.sel {
  border-color: var(--lightGreen);
  background: #e9f4f2;
}
.hgl-list .pay-opt i {
  color: var(--lightGreen);
  display: block;
  margin: 0 auto 8px;
}
.hgl-list .pay-opt .nm {
  font-size: 15px;
  font-weight: 700;
  color: var(--darkgreen);
}
/* Footer */
.hgl-list .sheet-foot {
  position: sticky;
  bottom: 0;
  background: var(--bg);
  padding: 14px 18px 20px;
  border-top: 1px solid var(--line);
  flex-shrink: 0;
}
.hgl-list .helper-text {
  text-align: center;
  font-size: 13px;
  color: var(--muted);
  margin-top: 10px;
}
.hgl-list .secondary-link {
  text-align: center;
  padding: 14px;
  color: var(--muted);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.hgl-list .back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 10px;
  margin-top: 4px;
  background: none;
  border: none;
  color: var(--muted);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  border-radius: 10px;
  transition: 0.15s;
}
.hgl-list .back-btn:hover {
  background: var(--line);
  color: var(--darkgreen);
}
.hgl-list .back-btn:active {
  opacity: 0.7;
}
/* ── TRANSITIONS ── */
/* Mobile: fade backdrop + slide panel */
.hgl-list .fade-detail-enter-active,
.hgl-list .fade-detail-leave-active {
  transition: opacity 0.2s ease;
}
.hgl-list .fade-detail-enter,
.hgl-list .fade-detail-leave-to {
  opacity: 0;
}
.hgl-list .fade-detail-enter-active .flow-panel {
  animation: slideUp 0.25s ease;
}
.hgl-list .fade-detail-leave-active .flow-panel {
  animation: slideUp 0.2s ease reverse;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
/* ── TABLET — center the column ── */

@media (min-width: 600px) and (max-width: 959px) {
  .hgl-list .list__main {
    max-width: 480px;
    margin: 0 auto;
    box-shadow: 0 0 40px rgba(12, 57, 50, 0.12);
  }
  .hgl-list .list__detail {
    align-items: center;
  }
  .hgl-list .flow-panel {
    border-radius: 20px;
    max-height: 90vh;
  }
}
</style>
